import { useMemo } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useStateSelector } from 'hooks';
import { routes } from 'configs/routes';

export const useTitle = () => {
  const location = useLocation();
  const menuConfig = useStateSelector((state) => state.home.menuConfig);

  return useMemo(() => {
    const currentRoute = routes.find((route) =>
      matchPath(location.pathname, route)
    );

    if (!currentRoute) return null;

    let menuItem = menuConfig.find(
      (menuItem) => menuItem.Id === currentRoute.id
    );

    return menuItem?.Label ?? null;
  }, [menuConfig, location]);
};
